define("ROOM4.CCAProductGallery.CCAProductGallery.PackageItems.View", [
  "room4_ccaproductgallery_package_items.tpl",
  "ROOM4.CCAProductGallery.CCAProductGallery.Model",
  "ROOM4.CCAProductGallery.CCAProductGallery.SchemaHelper",
  "ROOM4.CCAProductGallery.CCAProductGallery.PackageItemQuote.Model",
  "ROOM4.CCAProductGallery.CCAProductGallery.PackageItemQuote.View",
  "Backbone",
  "Utils",
], function (
  room4_ccaproductgallery_package_items_tpl,
  CCAProductGalleryModel,
  SchemaHelper,
  PackageItemQuoteModel,
  PackageItemQuoteView,
  Backbone,
  Utils
) {
  "use strict";

  function toNumber(value) {
    return SchemaHelper.toNumber(value);
  }

  function formatCurrency(value) {
    var amount = toNumber(value);

    return amount === null ? "" : "$" + amount.toFixed(2);
  }

  function getPackageItemTitle(component) {
    return (
      component.displayname ||
      component.itemname ||
      component.itemnumber ||
      Utils.translate("Package Item")
    );
  }

  function getImageNotAvailableUrl() {
    var configuration =
      typeof SC !== "undefined" && SC.CONFIGURATION ? SC.CONFIGURATION : {};

    return configuration.imageNotAvailable || "";
  }

  function getItemUrl(urlComponent) {
    return "/" + String(urlComponent || "").replace(/^\/+/, "");
  }

  function toPositiveQuantity(value) {
    var parsed = parseInt(value, 10);

    return !isNaN(parsed) && parsed > 0 ? parsed : 1;
  }

  return Backbone.View.extend({
    template: room4_ccaproductgallery_package_items_tpl,

    events: {
      "click .ccaproductgallery-package-quantity-remove": "changeQuantity",
      "click .ccaproductgallery-package-quantity-add": "changeQuantity",
      "change .ccaproductgallery-package-quantity-value": "normalizeQuantity",
      "click .ccaproductgallery-package-add-to-cart": "addItemToCart",
      "click .ccaproductgallery-package-purchase-button": "addPackageToCart",
      "click .ccaproductgallery-package-quote-button-package": "addPackageToQuote",
    },

    initialize: function initialize(options) {
      this.model = options.model;
      this.container = options.container;
      this.canonicalUrl = options.canonicalUrl || "";
      this.cart = SC.Application.getComponent("Cart");
      this.availabilityModel = new CCAProductGalleryModel();
      this.availabilityChecked = false;
      this.isAddingPackage = false;
      this.isAddingPackageToQuote = false;
      this.quoteItemViews = [];
      this.on("afterViewRender", this.scheduleAvailabilityCheck, this);
      this.on("afterViewRender", this.renderQuoteItemViews, this);
    },

    destroy: function destroy() {
      this.destroyQuoteItemViews();

      return this._destroy();
    },

    destroyQuoteItemViews: function destroyQuoteItemViews() {
      this.$(".ccaproductgallery-package-row").removeData("quoteModel");

      while (this.quoteItemViews.length) {
        this.quoteItemViews.pop().destroy();
      }
    },

    getComponentByItemId: function getComponentByItemId(itemId) {
      var components = (this.model && this.model.get("components")) || [];
      var normalizedItemId = String(itemId || "");
      var index;

      for (index = 0; index < components.length; index += 1) {
        if (String(components[index].itemid || "") === normalizedItemId) {
          return components[index];
        }
      }

      return null;
    },

    renderQuoteItemViews: function renderQuoteItemViews() {
      var self = this;

      this.destroyQuoteItemViews();

      this.$(".ccaproductgallery-package-quote-action").each(function () {
        var $quoteAction = self.$(this);
        var $row = $quoteAction.closest(".ccaproductgallery-package-row");
        var itemId = parseInt($quoteAction.attr("data-item-id"), 10);
        var quoteModel;
        var quoteView;

        if (!itemId || isNaN(itemId)) {
          return;
        }

        quoteModel = new PackageItemQuoteModel(
          {
            itemId: itemId,
          },
          {
            container: self.container,
            component: self.getComponentByItemId(itemId),
            quantityProvider: function quantityProvider() {
              return self.getRowQuantity($row);
            },
          }
        );
        quoteView = new PackageItemQuoteView({
          model: quoteModel,
        });

        quoteView.setElement($quoteAction);
        quoteView.render();
        $row.data("quoteModel", quoteModel);
        self.quoteItemViews.push(quoteView);
      });
    },

    isQuoteEnabled: function isQuoteEnabled() {
      return !!(
        this.container &&
        this.container.ProductListModule &&
        this.container.ProductListModule.Utils &&
        this.container.ProductListModule.Utils.isProductListEnabled &&
        this.container.ProductListModule.Utils.isProductListEnabled()
      );
    },

    updateRowTotal: function updateRowTotal($row, quantity) {
      var unitPrice = toNumber($row.attr("data-unit-price"));
      var totalPrice = unitPrice === null ? "" : formatCurrency(unitPrice * quantity);

      $row.find(".ccaproductgallery-package-total").text(totalPrice);
    },

    setRowQuantity: function setRowQuantity($row, quantity) {
      var normalizedQuantity = toPositiveQuantity(quantity);

      $row
        .find(".ccaproductgallery-package-quantity-value")
        .val(normalizedQuantity);
      this.updateRowTotal($row, normalizedQuantity);
      this.updateRowAvailabilityForQuantity($row);
    },

    changeQuantity: function changeQuantity(event) {
      var $button = this.$(event.currentTarget);
      var $row = $button.closest(".ccaproductgallery-package-row");
      var $input = $row.find(".ccaproductgallery-package-quantity-value");
      var quantity = toPositiveQuantity($input.val());
      var action = $button.attr("data-action");

      if (action === "plus") {
        quantity += 1;
      } else if (action === "minus") {
        quantity -= 1;
      }

      this.setRowQuantity($row, quantity);
    },

    normalizeQuantity: function normalizeQuantity(event) {
      var $input = this.$(event.currentTarget);
      var $row = $input.closest(".ccaproductgallery-package-row");

      this.setRowQuantity($row, $input.val());
    },

    getRowQuantity: function getRowQuantity($row) {
      return toPositiveQuantity(
        $row.find(".ccaproductgallery-package-quantity-value").val()
      );
    },

    setRowControlsDisabled: function setRowControlsDisabled($row, disabled) {
      $row
        .find(
          ".ccaproductgallery-package-add-to-cart, " +
            ".ccaproductgallery-package-quantity button, " +
            ".ccaproductgallery-package-quantity-value"
        )
        .prop("disabled", disabled);
    },

    setRowsControlsDisabled: function setRowsControlsDisabled($rows, disabled) {
      var self = this;

      $rows.each(function (index) {
        self.setRowControlsDisabled($rows.eq(index), disabled);
      });
    },

    setRowQuoteControlsDisabled: function setRowQuoteControlsDisabled($row, disabled) {
      $row
        .find(
          ".ccaproductgallery-package-add-to-quote, " +
            ".ccaproductgallery-package-quantity button, " +
            ".ccaproductgallery-package-quantity-value"
        )
        .prop("disabled", disabled);
    },

    setRowsQuoteControlsDisabled: function setRowsQuoteControlsDisabled(
      $rows,
      disabled
    ) {
      var self = this;

      $rows.each(function (index) {
        self.setRowQuoteControlsDisabled($rows.eq(index), disabled);
      });
    },

    setPackagePurchaseDisabled: function setPackagePurchaseDisabled(disabled) {
      this.$(".ccaproductgallery-package-purchase-button").prop(
        "disabled",
        disabled
      );
    },

    setPackagePurchaseText: function setPackagePurchaseText(text) {
      this.$(".ccaproductgallery-package-purchase-button").text(text);
    },

    setPackageQuoteDisabled: function setPackageQuoteDisabled(disabled) {
      this.$(".ccaproductgallery-package-quote-button-package").prop(
        "disabled",
        disabled
      );
    },

    setPackageQuoteText: function setPackageQuoteText(text) {
      this.$(".ccaproductgallery-package-quote-button-package").text(text);
    },

    setRowPurchaseDisabled: function setRowPurchaseDisabled($row, disabled) {
      $row.find(".ccaproductgallery-package-add-to-cart").prop(
        "disabled",
        disabled
      );
    },

    getPackagePurchaseButton: function getPackagePurchaseButton() {
      return this.$(".ccaproductgallery-package-purchase-button");
    },

    getAvailabilityItemIds: function getAvailabilityItemIds() {
      var components = (this.model && this.model.get("components")) || [];
      var itemIds = [];
      var seenItemIds = {};

      components.forEach(function (component) {
        var itemId = component && component.itemid;

        if (itemId && !seenItemIds[itemId]) {
          seenItemIds[itemId] = true;
          itemIds.push(itemId);
        }
      });

      return itemIds;
    },

    scheduleAvailabilityCheck: function scheduleAvailabilityCheck() {
      var self = this;

      if (this.availabilityCheckStarted) {
        return;
      }

      this.availabilityCheckStarted = true;
      this.setPackagePurchaseText(Utils.translate("Checking availability..."));
      this.setRowsAvailabilityState("checking");

      setTimeout(function () {
        self.checkPackageAvailability();
      }, 100);
    },

    setRowsAvailabilityState: function setRowsAvailabilityState(state, message) {
      var self = this;
      var $rows = this.$(".ccaproductgallery-package-row");

      $rows.each(function (index) {
        self.setRowAvailabilityState($rows.eq(index), state, message);
      });
    },

    setRowAvailabilityState: function setRowAvailabilityState($row, state, message) {
      var isChecking = state === "checking";
      var isAvailable = state === "available";
      var isCartPriceEnabled =
        $row.attr("data-cart-price-enabled") !== "false";
      var isAvailableToCart = isAvailable && isCartPriceEnabled;

      $row
        .attr("data-availability-state", state)
        .find(".ccaproductgallery-package-availability")
        .removeClass(
          "ccaproductgallery-package-availability-checking " +
            "ccaproductgallery-package-availability-available " +
            "ccaproductgallery-package-availability-unavailable"
        )
        .addClass("ccaproductgallery-package-availability-" + state)
        .text(
          message ||
            (isChecking
              ? Utils.translate("Checking availability...")
              : Utils.translate("Contact for availability."))
        );

      $row.attr("data-available-to-cart", isAvailableToCart ? "true" : "false");
      this.setRowPurchaseDisabled($row, !isAvailableToCart);
      this.updatePackagePurchaseAvailability();
    },

    updateRowAvailabilityForQuantity: function updateRowAvailabilityForQuantity($row) {
      var availableStock = toNumber($row.attr("data-available-stock"));

      if (!this.availabilityChecked || availableStock === null) {
        return;
      }

      if (availableStock >= this.getRowQuantity($row)) {
        this.setRowAvailabilityState(
          $row,
          "available",
          Utils.translate("Available")
        );
      } else if (availableStock > 0) {
        this.setRowAvailabilityState(
          $row,
          "unavailable",
          Utils.translate("Only $(0) available.", availableStock)
        );
      } else {
        this.setRowAvailabilityState(
          $row,
          "unavailable",
          Utils.translate("Contact for availability.")
        );
      }
    },

    hasUnavailablePendingRows: function hasUnavailablePendingRows() {
      var unavailableRows = this.getPendingRows().filter(function () {
        return this.getAttribute("data-available-to-cart") !== "true";
      });

      return !!unavailableRows.length;
    },

    updatePackagePurchaseAvailability: function updatePackagePurchaseAvailability() {
      var $button = this.getPackagePurchaseButton();

      if (!$button.length || this.isAddingPackage) {
        return;
      }

      if (!this.getPendingRows().length) {
        this.markPackageAddedToCart();
        return;
      }

      if (!this.availabilityChecked) {
        this.setPackagePurchaseText(Utils.translate("Checking availability..."));
        this.setPackagePurchaseDisabled(true);
        return;
      }

      this.setPackagePurchaseText(Utils.translate("Purchase this package"));
      this.setPackagePurchaseDisabled(this.hasUnavailablePendingRows());
    },

    checkPackageAvailability: function checkPackageAvailability() {
      var self = this;
      var itemIds = this.getAvailabilityItemIds();

      if (!itemIds.length) {
        this.availabilityChecked = true;
        this.setRowsAvailabilityState(
          "unavailable",
          Utils.translate("Unable to confirm availability.")
        );
        return;
      }

      this.availabilityModel
        .fetch({
          data: {
            action: "availability",
            itemIds: itemIds.join(","),
          },
        })
        .then(function (response) {
          self.availabilityChecked = true;
          self.applyAvailabilityResults(response);
        }, function (error) {
          self.handleAvailabilityError(error);
        });
    },

    applyAvailabilityResults: function applyAvailabilityResults(response) {
      var self = this;
      var items = (response && response.items) || {};

      this.$(".ccaproductgallery-package-row").each(function (index) {
        var $row = self.$(".ccaproductgallery-package-row").eq(index);
        var itemId = String($row.attr("data-item-id") || "");
        var itemAvailability = items[itemId] || {};
        var totalAvailableStock =
          toNumber(itemAvailability.totalAvailable) || 0;

        $row.attr("data-available-stock", totalAvailableStock);
        self.updateRowAvailabilityForQuantity($row);
      });

      this.updatePackagePurchaseAvailability();
    },

    handleAvailabilityError: function handleAvailabilityError(error) {
      if (typeof console !== "undefined" && console.error) {
        console.error("Unable to check gallery package availability:", error);
      }

      this.availabilityChecked = true;
      this.setRowsAvailabilityState(
        "unavailable",
        Utils.translate("Unable to confirm availability.")
      );
      this.updatePackagePurchaseAvailability();
    },

    markPackageAddedToCart: function markPackageAddedToCart() {
      this.$(".ccaproductgallery-package-purchase").html(
        '<span class="ccaproductgallery-package-added-label">' +
          Utils.translate("Package Added to Cart") +
          "</span>"
      );
    },

    markPackageAddedToQuote: function markPackageAddedToQuote() {
      this.setPackageQuoteText(Utils.translate("Package Added to Quote"));
      this.setPackageQuoteDisabled(true);
    },

    getPendingRows: function getPendingRows() {
      return this.$(".ccaproductgallery-package-row").filter(function () {
        return this.getAttribute("data-added-to-cart") !== "true";
      });
    },

    syncPackagePurchaseState: function syncPackagePurchaseState() {
      if (!this.getPendingRows().length) {
        this.markPackageAddedToCart();
      }
    },

    markRowAddedToCart: function markRowAddedToCart($row) {
      $row
        .addClass("ccaproductgallery-package-row-added")
        .attr("data-added-to-cart", "true");
      this.setRowControlsDisabled($row, true);
      $row
        .find(".ccaproductgallery-package-cart-action")
        .html(
          '<span class="ccaproductgallery-package-added-label">' +
            Utils.translate("Added to Cart") +
            "</span>"
        );
      this.syncPackagePurchaseState();
    },

    markRowAddedToQuote: function markRowAddedToQuote($row) {
      var quoteModel = $row.data("quoteModel");

      if (quoteModel) {
        quoteModel.set("isAddedToQuote", true);
      }
    },

    addRowToCart: function addRowToCart($row, success, failure) {
      var self = this;
      var itemId = parseInt($row.attr("data-item-id"), 10);
      var quantity = this.getRowQuantity($row);
      var addLinePromise;

      if (
        !this.cart ||
        !itemId ||
        isNaN(itemId) ||
        !this.availabilityChecked ||
        $row.attr("data-available-to-cart") !== "true"
      ) {
        if (failure) {
          failure();
        }
        return;
      }

      this.setRowControlsDisabled($row, true);

      addLinePromise = this.cart.addLine({
        line: {
          quantity: quantity,
          item: {
            internalid: itemId,
          },
        },
      });

      if (addLinePromise && addLinePromise.done && addLinePromise.fail) {
        addLinePromise.done(function () {
          self.markRowAddedToCart($row);
          if (success) {
            success();
          }
        });
        addLinePromise.fail(function (error) {
          self.setRowControlsDisabled($row, false);
          self.logAddToCartError(error);
          if (failure) {
            failure(error);
          }
        });
      } else if (addLinePromise && addLinePromise.then) {
        addLinePromise.then(function () {
          self.markRowAddedToCart($row);
          if (success) {
            success();
          }
        }, function (error) {
          self.setRowControlsDisabled($row, false);
          self.logAddToCartError(error);
          if (failure) {
            failure(error);
          }
        });
      } else {
        this.markRowAddedToCart($row);
        if (success) {
          success();
        }
      }
    },

    addItemToCart: function addItemToCart(event) {
      var $button = this.$(event.currentTarget);
      var $row = $button.closest(".ccaproductgallery-package-row");

      event.preventDefault();
      this.addRowToCart($row);
    },

    addPackageToCart: function addPackageToCart(event) {
      var self = this;
      var $rows = this.getPendingRows();

      event.preventDefault();

      if (
        !this.cart ||
        !$rows.length ||
        !this.availabilityChecked ||
        this.hasUnavailablePendingRows()
      ) {
        return;
      }

      this.isAddingPackage = true;
      this.setPackagePurchaseDisabled(true);
      this.setPackagePurchaseText(Utils.translate("Adding..."));
      this.setRowsControlsDisabled($rows, true);

      function addNextRow(index) {
        if (index >= $rows.length) {
          self.isAddingPackage = false;
          self.markPackageAddedToCart();
          return;
        }

        self.addRowToCart($rows.eq(index), function () {
          addNextRow(index + 1);
        }, function () {
          self.isAddingPackage = false;
          self.setPackagePurchaseDisabled(false);
          self.setPackagePurchaseText(Utils.translate("Purchase this package"));
          self.setRowsControlsDisabled(self.getPendingRows(), false);
          self.updatePackagePurchaseAvailability();
        });
      }

      addNextRow(0);
    },

    getQuoteRows: function getQuoteRows() {
      return this.$(".ccaproductgallery-package-row");
    },

    getPackageQuoteGroups: function getPackageQuoteGroups($rows) {
      var groups = [];
      var groupsByKey = {};

      $rows.each(function (index) {
        var $row = $rows.eq(index);
        var quoteModel = $row.data("quoteModel");
        var key;

        if (!quoteModel) {
          return;
        }

        key = quoteModel.getQuoteLineKey();

        if (!groupsByKey[key]) {
          groupsByKey[key] = {
            quoteModel: quoteModel,
            quantity: 0,
            rows: [],
          };
          groups.push(groupsByKey[key]);
        }

        groupsByKey[key].quantity += quoteModel.getQuantity();
        groupsByKey[key].rows.push($row);
      });

      groups.forEach(function (group) {
        group.quoteModel = group.quoteModel.cloneWithQuantity(group.quantity);
      });

      return groups;
    },

    addPackageToQuote: function addPackageToQuote(event) {
      var self = this;
      var $rows = this.getQuoteRows();
      var quoteGroups;
      var firstQuoteModel;
      var groupedRowCount = 0;

      event.preventDefault();

      if (!$rows.length || this.isAddingPackageToQuote || !this.isQuoteEnabled()) {
        return;
      }

      quoteGroups = this.getPackageQuoteGroups($rows);
      firstQuoteModel = quoteGroups.length ? quoteGroups[0].quoteModel : null;
      quoteGroups.forEach(function (quoteGroup) {
        groupedRowCount += quoteGroup.rows.length;
      });

      if (groupedRowCount !== $rows.length) {
        this.logAddToQuoteError();
        return;
      }

      if (!firstQuoteModel || !firstQuoteModel.validateLogin()) {
        return;
      }

      this.isAddingPackageToQuote = true;
      this.setPackageQuoteDisabled(true);
      this.setPackageQuoteText(Utils.translate("Adding..."));
      this.setRowsQuoteControlsDisabled($rows, true);

      function restorePackageQuoteButton(error) {
        self.isAddingPackageToQuote = false;
        self.setPackageQuoteDisabled(false);
        self.setPackageQuoteText(Utils.translate("Add Package to Quote"));
        self.setRowsQuoteControlsDisabled($rows, false);
        self.logAddToQuoteError(error);
      }

      function markGroupAddedToQuote(group) {
        group.rows.forEach(function ($row) {
          self.markRowAddedToQuote($row);
        });
      }

      function addNextGroup(productListJson, index) {
        var quoteGroup;
        var addQuotePromise;

        if (index >= quoteGroups.length) {
          self.isAddingPackageToQuote = false;
          self.setRowsQuoteControlsDisabled($rows, false);
          firstQuoteModel.notifyQuoteChanged();
          self.markPackageAddedToQuote();
          return;
        }

        quoteGroup = quoteGroups[index];
        addQuotePromise = quoteGroup.quoteModel.addToQuoteProductList(
          productListJson
        );

        addQuotePromise.done(function () {
          markGroupAddedToQuote(quoteGroup);
          addNextGroup(productListJson, index + 1);
        });
        addQuotePromise.fail(restorePackageQuoteButton);
      }

      firstQuoteModel
        .getOrCreateQuoteProductList()
        .done(function (productListJson) {
          addNextGroup(productListJson, 0);
        })
        .fail(restorePackageQuoteButton);
    },

    logAddToCartError: function logAddToCartError(error) {
      if (typeof console !== "undefined" && console.error) {
        console.error("Unable to add gallery package item to cart:", error);
      }
    },

    logAddToQuoteError: function logAddToQuoteError(error) {
      if (typeof console !== "undefined" && console.error) {
        console.error("Unable to add gallery package item to quote:", error);
      }
    },

    getPackageItems: function getPackageItems() {
      var components = (this.model && this.model.get("components")) || [];
      var imageNotAvailableUrl = getImageNotAvailableUrl();
      var packageItems = [];
      var pageUrl =
        this.canonicalUrl ||
        SchemaHelper.getAbsoluteUrl(
          "/gallery/" +
            encodeURIComponent((this.model && this.model.get("slug")) || "")
        );

      components.forEach(function (component, index) {
        var quantity = toPositiveQuantity(component.quantity);
        var unitPrice = toNumber(component.onlineprice);
        var imageUrl = component.imageurl || imageNotAvailableUrl;
        var hasContactPricing = unitPrice === null;
        var schemaProduct = SchemaHelper.getProductSchemaContext(
          component,
          index,
          pageUrl,
          Utils.translate("Package Item")
        );

        packageItems.push({
          internalid: component.itemid || "",
          title: getPackageItemTitle(component),
          brand: component.brand || "",
          model: component.model || "",
          itemnumber: component.itemnumber || "",
          itemUrl: getItemUrl(component.urlcomponent),
          imageurl: imageUrl,
          quantity: quantity,
          quantityInputId:
            "quantity-gallery-package-" +
            (component.itemid || component.internalid || ""),
          rawUnitPrice: hasContactPricing ? "" : unitPrice,
          unitPrice: formatCurrency(unitPrice),
          totalPrice:
            hasContactPricing ? "" : formatCurrency(unitPrice * quantity),
          hasContactPricing: hasContactPricing,
          isCartPriceEnabled: !hasContactPricing,
          cartPriceEnabled: hasContactPricing ? "false" : "true",
          contactPricingMessage: Utils.translate("Contact for pricing"),
          hasImage: !!imageUrl,
          hasBrand: !!component.brand,
          hasItemNumber: !!component.itemnumber,
          hasSchemaProduct: !!schemaProduct,
          schemaDomId: schemaProduct ? schemaProduct.domId : "",
          schemaProductId: schemaProduct ? schemaProduct.id : "",
          schemaCategory: schemaProduct ? schemaProduct.category : "",
          schemaUrl: schemaProduct ? schemaProduct.url : "",
          schemaImageUrl: schemaProduct ? schemaProduct.image : "",
          schemaDescription: schemaProduct ? schemaProduct.description : "",
          schemaItemCondition: schemaProduct
            ? schemaProduct.itemCondition
            : "",
          schemaAdditionalProperties: schemaProduct
            ? schemaProduct.additionalProperties
            : [],
          schemaAvailability: schemaProduct ? schemaProduct.availability : "",
          schemaPriceCurrency: schemaProduct
            ? schemaProduct.priceCurrency
            : "",
          hasSchemaBrand: !!(schemaProduct && schemaProduct.hasBrand),
          hasSchemaModel: !!(schemaProduct && schemaProduct.hasModel),
          hasSchemaAdditionalProperties: !!(
            schemaProduct && schemaProduct.hasAdditionalProperties
          ),
          hasSchemaUrl: !!(schemaProduct && schemaProduct.hasUrl),
          hasSchemaImage: !!(schemaProduct && schemaProduct.hasImage),
          hasSchemaDescription: !!(
            schemaProduct && schemaProduct.hasDescription
          ),
          hasSchemaPrice: !!(schemaProduct && schemaProduct.hasPrice),
        });
      });

      return packageItems;
    },

    getContext: function getContext() {
      var packageItems = this.getPackageItems();

      return {
        packageItems: packageItems,
        hasPackageItems: !!packageItems.length,
        isQuotable: this.isQuoteEnabled(),
      };
    },
  });
});
